// @ts-nocheck
"use client";
import { useEffect, useState } from "react";
import styles from './cookie-banner.module.css';
import Card from "./card";
import { FaCookie, FaCookieBite } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import clsx from "clsx";
import { TbCookieOff } from "react-icons/tb";
import Link from "next/link";
import { saveAndAccept } from "../../utils/ga4noScript";
import { HiShieldCheck } from "react-icons/hi2";

const CookieBanner = ({ onConsentGiven, isCalifornia, isEU, isCcpaOptOut }) => {
  const [showBanner, setShowBanner] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const [popUp, setPopUp] = useState(false);
  const [adsConsent, setAdsConsent] = useState(false);
  const [analyticsConsent, setAnalyticsConsent] = useState(false);
  const [functionsConsent, setFunctionsConsent] = useState(false);

  // Check existing consent on load
  useEffect(() => {

    const consent = localStorage.getItem("cookie_consent");
    const parsed = JSON.parse(consent);

    if (!consent || isCcpaOptOut) {
      setShowBanner(true);
    } else {
      
      if (parsed.analytics === true && window.gtag) {
        window.gtag("consent", "update", {
          analytics_storage: "granted",
          ad_storage: "granted",
          functionality_storage: "granted"
        });
      }
    }
  }, []);

  const acceptAll = async () => {
    saveAndAccept(true,true,true,onConsentGiven);
  };
  const rejectAll = async () => {
    saveAndAccept(false,false,false,onConsentGiven);
  };
  const acceptButDoNotSell = async () => {
    saveAndAccept(false,true,true,onConsentGiven);
  };

  const hideOrReject = async () => {
    if(isEU){
      saveAndAccept(false,false,false,onConsentGiven);
    }else{
      saveAndAccept(true,true,true,onConsentGiven);
    }
  };

  return showBanner ? (
    showCookieBanner && <div className={clsx(styles["consent-wrapper"], { [styles["inset"]]: popUp })}>
      {popUp && (
        <div className={styles["pop-up-cookie-card"]}>
          <Card divBlock={
            <div className={styles["pop-up-content"]}>
              <div>Privacy Overview <IoClose onClick={() => setPopUp(false)} /></div>
              <div className={styles["pop-up-msg"]}>
                <div>
                  This website uses cookies to improve your experience while you navigate through the website. Out of these cookies, the cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent. You also have the option to opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing experience.
                </div>
                <details>
                  <summary>Necessary <p>Always Enabled</p></summary>
                  <div className={styles["cookie-details-content"]}>
                    Necessary cookies are absolutely essential for the website to function properly. This category only includes cookies that ensures basic functionalities and security features of the website. These cookies do not store any personal information.
                  </div>
                </details>
                <details>
                  <summary>
                    Non-Necessary
                    <label>
                      Ads{" "}
                      <input
                        type="checkbox"
                        checked={adsConsent}
                        onChange={() => setAdsConsent(!adsConsent)}
                      />
                    </label>
                    <label>
                      Analytics{" "}
                      <input
                        type="checkbox"
                        checked={analyticsConsent}
                        onChange={() => setAnalyticsConsent(!analyticsConsent)}
                      />
                    </label>
                    {/* <label>
                      Functionalities{" "}
                      <input
                        type="checkbox"
                        checked={functionsConsent}
                        onChange={() => setFunctionsConsent(!functionsConsent)}
                      />
                    </label> */}
                  </summary>
                  <div className={styles["cookie-details-content"]}>
                    Any cookies that may not be particularly necessary for the website to function and is used specifically to collect user personal data via analytics, ads, other embedded contents are termed as non-necessary cookies. It is mandatory to procure user consent prior to running these cookies on your website.
                  </div>
                </details>
                <div className={styles["cookie-btn-wrapper"]}>
                  <button onClick={() => saveAndAccept(adsConsent,analyticsConsent,functionsConsent,onConsentGiven)}>
                    <div>Save & Accept <FaCookie /></div>
                    <div>Save & Accept <FaCookieBite /></div>
                  </button>
                </div>
              </div>
            </div>
          } />
        </div>
      )}
      <div className={styles["cookie-card"]}>
        <Card divBlock={
          <div className={styles["cookie-content"]}>
            <div>This site uses cookies
              {/* <IoClose onClick={hideOrReject} title={isEU ? "Close and reject." : "Close and accept."}/> */}
            </div>
            {isCcpaOptOut && <div className={styles["opt-out-honor"]}> <HiShieldCheck size={22}/> Opt-Out Request Honored</div>}
            <div className={styles["cookie-msg"]}>
              <div>
                This website uses cookies to improve your experience. We'll assume you're ok with this, but you can opt-out if you wish. <a href="/privacy-policy" target="_blank">Learn how we use your data here.</a> 
                <span 
                  style={{'display':'none'}}
                > California residents may opt out of the sale or sharing of personal information by clicking <i><Link href={"/do-not-sell-or-share-my-personal-information"} style={{"textDecoration": 'underline', 'cursor': 'pointer', fontWeight: 500}}>"Do Not Sell or Share My Personal Information".</Link></i></span>
              </div>
              <div className={styles["cookie-btn-wrapper"]}>
                <button onClick={acceptAll}>
                  <div>Accept All <FaCookie /></div>
                  <div>Accept All <FaCookieBite /></div>
                </button>
                <button onClick={rejectAll}
                >
                  <div>Reject All <TbCookieOff /></div>
                  <div>Reject All <TbCookieOff /></div>
                </button>
                <button onClick={() => setPopUp(true)}>Cookie Settings</button>
              </div>
            </div>
          </div>
        } />
      </div>
    </div>
  ) : null;
};

export default CookieBanner;
